<app-strategy-list [campaignType]="CampaignType.SP" (strategyCreationClick)="createStrategy()"></app-strategy-list>
